export const getStorageRef = () => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const firebase = getFirebase();
        const storage = firebase.storage();

        dispatch({ type: 'GET_STORAGE', storage });
    }
};